/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Sidebar_MetadataInputs */

const cs_blog_sidebar_metadata = /** @type {(inputs: Blog_Sidebar_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL a metadata`)
};

const en_blog_sidebar_metadata = /** @type {(inputs: Blog_Sidebar_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL & metadata`)
};

/**
* | output |
* | --- |
* | "URL & metadata" |
*
* @param {Blog_Sidebar_MetadataInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_sidebar_metadata = /** @type {((inputs?: Blog_Sidebar_MetadataInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Sidebar_MetadataInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_sidebar_metadata(inputs)
	return cs_blog_sidebar_metadata(inputs)
});